// removed by extract-text-webpack-plugin
module.exports = {"root":"StoryFooter__root--1dV2E","center":"StoryFooter__center--3mtm-","icon":"StoryFooter__icon--2--K0","section":"StoryFooter__section--1mAV5","primary":"StoryFooter__primary--1UxmJ","bounce":"StoryFooter__bounce--11Q1R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/StoryFooter/StoryFooter.css
// module id = ./src/components/Library/StoryFooter/StoryFooter.css
// module chunks = 4